import { QueryHookResult, useGenericQuery } from '../useGenericQuery'
import { queryKeys } from '../queryRegistry'
import { Task } from 'axiosApi/models';
import { useApi } from 'api/ApiProvider';
import Api from 'axiosApi/api';

export const useTaskByEmployeeAndProject = (idEmployee: number, idProject: number): QueryHookResult<Task> => {
  const { jobsApi }: Api = useApi()
  return useGenericQuery<Task>({
    queryKey: queryKeys.taskByEmployeeAndProject(idEmployee, idProject),
    queryFn: async (): Promise<Task[]> => {
      if (!idEmployee || !idProject) {
        return [];
      }
      const response = await jobsApi.apiVversionTaskGetByEmployeeAndProjectIdEmployeeIdProjectGet(idEmployee, idProject, "1")
      const { data } = response?.data;
      return data?.queryResult || [];
    }
  })
}